
import store from '../store/store';
import userModel from '../store/models/user'

const user = {
    getDateFormat: () => { return store.getters.user.getSetting(userModel.settingKeys.DATE_FORMAT) },
    getTimeFormat: () => { return store.getters.user.getSetting(userModel.settingKeys.TIME_FORMAT) },
    getPostFormat: () => { return store.getters.user.getSetting(userModel.settingKeys.POST_FORMAT) },
    getPostOrder: () => { return store.getters.user.getSetting(userModel.settingKeys.POST_ORDER) },    
    getPostsPerPage: () => { return store.getters.user.getSetting(userModel.settingKeys.POSTS_PER_PAGE) },
    getTopicsPerPage: () => { return store.getters.user.getSetting(userModel.settingKeys.TOPICS_PER_PAGE) },
    getUseMessaging: () => { return store.getters.user.getSetting(userModel.settingKeys.USE_MESSAGING) },
    getUseEmoticons: () => { return store.getters.user.getSetting(userModel.settingKeys.USE_EMOTICONS) },
    getViewSignatures: () => { return store.getters.user.getSetting(userModel.settingKeys.VIEW_SIGNATURES) },
    getViewAvatars: () => { return store.getters.user.getSetting(userModel.settingKeys.VIEW_AVATARS) },
    getSelectedTheme: () => { return store.getters.user.getSetting(userModel.settingKeys.THEME) },
    getFontSize: () => { return store.getters.user.getSetting(userModel.settingKeys.FONT_SIZE) },
    getFontColor: () => { return store.getters.user.getSetting(userModel.settingKeys.FONT_COLOR) },
    getFontWeight: () => { return store.getters.user.getSetting(userModel.settingKeys.FONT_WEIGHT) },
    getAutoSubscribeTopicReplySiteNotification: () => { return store.getters.user.getSetting(userModel.settingKeys.AUTO_SUBSCRIBE_TOPIC_REPLY_SITE_NOTIFICATION) },
    getAutoSubscribeTopicReplyEmail: () => { return store.getters.user.getSetting(userModel.settingKeys.AUTO_SUBSCRIBE_TOPIC_REPLY_EMAIL) },
    getAutoSubscribeTopicCreateSiteNotification: () => { return store.getters.user.getSetting(userModel.settingKeys.AUTO_SUBSCRIBE_TOPIC_CREATE_SITE_NOTIFICATION) },
    getAutoSubscribeTopicCreateEmail: () => { return store.getters.user.getSetting(userModel.settingKeys.AUTO_SUBSCRIBE_TOPIC_CREATE_EMAIL) },
    getCodeFontSize: () => { return store.getters.user.getSetting(userModel.settingKeys.CODE_FONT_SIZE) },
    getUseCKEditor: () => { return store.getters.user.getSetting(userModel.settingKeys.USE_CKEDITOR) },
}

const settings = {
    user: user
}

export default settings

